import _ from 'lodash';
import { LOAD_DOCUMENTS, UPDATE_DOCUMENT, REMOVE_DOCUMENT } from '../actions/types';

/**
 * Document reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = [], action) => {
  switch (action.type) {
    case LOAD_DOCUMENTS:
      return action.payload;

    case UPDATE_DOCUMENT: {
      return _.map(state, doc => (doc.id === action.payload.id ? action.payload : doc));
    }

    case REMOVE_DOCUMENT: {
      return _.map(state, doc => ({
        ...doc,
        files: _.filter(doc.files, file => file.file_id !== action.payload.fileId),
      }));
    }

    default:
      return state;
  }
};
